import { render, staticRenderFns } from "./afterSaleWaitApproveList.vue?vue&type=template&id=03ddde19&scoped=true&"
import script from "./afterSaleWaitApproveList.vue?vue&type=script&lang=js&"
export * from "./afterSaleWaitApproveList.vue?vue&type=script&lang=js&"
import style0 from "./afterSaleWaitApproveList.vue?vue&type=style&index=0&id=03ddde19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ddde19",
  null
  
)

export default component.exports